import { contentIsTranslation, getAssociatedContentTranslations, getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME, contentHasTranslations } from 'content-management-data-lib';
import { getContentIdsWithMultiLangVariations, getMultiLangGroupSize } from './contentUtils';
export const getHasCrmObjectsWithOnlyPrimarySelected = crmObjects => crmObjects.some(crmObject => {
  const translations = getAssociatedContentTranslations(crmObject);
  return !contentIsTranslation(crmObject) && translations.length > 0 && !translations.every(translation => crmObjects.some(obj => obj.objectId === translation.objectId));
});
export const getIsEntireMlangGroupSelected = crmObjects => {
  const allSelectedIdsAndMlangVariationIds = getContentIdsWithMultiLangVariations(crmObjects);
  return allSelectedIdsAndMlangVariationIds.every(id => !!crmObjects.find(obj => obj.objectId === id));
};
export const getBulkAddToLanguageGroupDisabledTooltipKey = selectedContent => {
  const languagesOfSelectedContent = [];
  let disabledTooltipKey = undefined;
  selectedContent.forEach(crmObject => {
    const language = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE);
    if (contentIsTranslation(crmObject) || contentHasTranslations(crmObject)) {
      disabledTooltipKey = 'alreadyInGroup';
    } else if (!language) {
      disabledTooltipKey = 'noLanguage';
    } else if (languagesOfSelectedContent.includes(language)) {
      disabledTooltipKey = 'duplicateLanguage';
    }
    if (language) {
      languagesOfSelectedContent.push(language);
    }
    return !disabledTooltipKey;
  });
  return disabledTooltipKey;
};
export const getLimitReachedDisabledTooltipKey = ({
  limitData,
  crmObjects: [crmObject],
  shouldDisableIfMultiLangLimitIsReachedButNotExceeded = false,
  canBeDisabledDueToMultiLangLimits = false
}) => {
  const {
    hasExceededContentGroupLimit,
    hasReachedContentObjectLimit,
    hasExceededContentObjectLimit,
    multiLangGroupSizeLimit
  } = limitData;
  if (hasExceededContentObjectLimit || hasExceededContentGroupLimit || hasReachedContentObjectLimit && !multiLangGroupSizeLimit) {
    return hasExceededContentGroupLimit && hasReachedContentObjectLimit ? 'bothContentObjectAndContentGroupLimitReached' : hasExceededContentGroupLimit ? 'contentGroupLimitReached' : 'contentObjectLimitReached';
  }
  if (hasReachedContentObjectLimit && !multiLangGroupSizeLimit && shouldDisableIfMultiLangLimitIsReachedButNotExceeded) {
    return 'contentObjectLimitReached';
  }
  if (canBeDisabledDueToMultiLangLimits) {
    const multiLangGroupSize = getMultiLangGroupSize(crmObject);
    if (multiLangGroupSizeLimit && multiLangGroupSize >= multiLangGroupSizeLimit) {
      if (multiLangGroupSize === multiLangGroupSizeLimit && shouldDisableIfMultiLangLimitIsReachedButNotExceeded) {
        return 'mLangLimitReached';
      } else if (multiLangGroupSize > multiLangGroupSizeLimit) {
        return 'mLangLimitExceeded';
      }
    }
  }
  return undefined;
};